import { RadioButtonSection, RadioButtonSectionGroup } from '@components'

import { Spacing } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useLegalMentionsModalForm } from '../../../../../../../../context/legalMentionsModalFormContext'
import { LatePaymentPenaltyRateCustomMentionField } from './elements/LatePaymentPenaltyRateCustomMentionField'
import { LatePaymentPenaltyRateMentionType } from './enums/latePaymentPenaltyRateMentionType'

export const LatePaymentPenaltyRateMentionsGroup = (): ReactElement => {
  const { t } = useTranslation()
  const { legalMentionsModalForm } = useLegalMentionsModalForm()
  const { control, setValue } = legalMentionsModalForm

  const customMention = useWatch({
    control,
    name: 'custom.latePaymentPenaltyRate',
  })

  const selectedMentionType =
    customMention === null ? LatePaymentPenaltyRateMentionType.Default : LatePaymentPenaltyRateMentionType.Custom

  const handleRadioChange = useCallback(
    (value?: LatePaymentPenaltyRateMentionType) => {
      if (value === LatePaymentPenaltyRateMentionType.Default && customMention !== null) {
        setValue('custom.latePaymentPenaltyRate', null, { shouldDirty: true })
      } else if (value === LatePaymentPenaltyRateMentionType.Custom && customMention === null) {
        setValue('custom.latePaymentPenaltyRate', '', { shouldDirty: true })
      }
    },
    [customMention, setValue],
  )

  return (
    <>
      <RadioButtonSectionGroup direction="column" spacing={Spacing.S16} value={selectedMentionType}>
        <RadioButtonSection<LatePaymentPenaltyRateMentionType>
          description={t(
            `settings.organization.external_invoice.legal_mentions.modal.late_payment_penalty_rate.default_mention.description`,
          )}
          label={t(
            `settings.organization.external_invoice.legal_mentions.modal.late_payment_penalty_rate.default_mention.title`,
          )}
          labelVariant="bodyLG"
          onChange={handleRadioChange}
          value={LatePaymentPenaltyRateMentionType.Default}
        />
        <RadioButtonSection<LatePaymentPenaltyRateMentionType>
          label={t(
            `settings.organization.external_invoice.legal_mentions.modal.late_payment_penalty_rate.custom_mention.title`,
          )}
          labelVariant="bodyLG"
          onChange={handleRadioChange}
          value={LatePaymentPenaltyRateMentionType.Custom}
        />
      </RadioButtonSectionGroup>
      {selectedMentionType === LatePaymentPenaltyRateMentionType.Custom && <LatePaymentPenaltyRateCustomMentionField />}
    </>
  )
}
